import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const QuickActions = ({ userRole = 'artist' }) => {
  const navigate = useNavigate();
  const { user, openLoginModal } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleAuthAction = (path) => {
    setIsOpen(false);
    if (!user) {
      openLoginModal();
      return;
    }
    navigate(path);
  };

  const artistActions = [
    {
      label: 'Kampanya Oluştur',
      icon: 'Plus',
      color: 'primary',
      action: () => handleAuthAction('/campaign-creation-wizard')
    },
    {
      label: 'Influencer Bul',
      icon: 'Search',
      color: 'secondary',
      action: () => {
        navigate('/');
        setIsOpen(false);
      }
    },
    {
      label: 'Tekliflerim',
      icon: 'FileText',
      color: 'accent',
      action: () => handleAuthAction('/campaign-management?tab=proposals')
    }
  ];

  const influencerActions = [
    {
      label: 'Kampanyalara Göz At',
      icon: 'Briefcase',
      color: 'primary',
      action: () => {
        navigate('/campaign-management?view=available');
        setIsOpen(false);
      }
    },
    {
      label: 'Teklif Gönder',
      icon: 'Send',
      color: 'secondary',
      action: () => handleAuthAction('/campaign-management?action=propose')
    },
    {
      label: 'Portföyü Güncelle',
      icon: 'Edit',
      color: 'accent',
      action: () => handleAuthAction('/influencer-profile-creation')
    }
  ];

  const actions = userRole === 'artist' ? artistActions : influencerActions;

  return (
    <div ref={menuRef} className="fixed bottom-20 right-6 md:bottom-6 z-[1200]">
      {isOpen && (
        <div className="absolute bottom-16 right-0 mb-2 w-56 bg-popover border border-border rounded-lg shadow-elevation-3 animate-slide-in">
          <div className="p-2">
            {actions?.map((action, index) => (
              <button
                key={index}
                onClick={action?.action}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm hover:bg-muted transition-smooth"
              >
                <div className={`
                  w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0
                  ${action?.color === 'primary' ? 'bg-primary/10' : ''}
                  ${action?.color === 'secondary' ? 'bg-secondary/10' : ''}
                  ${action?.color === 'accent' ? 'bg-accent/10' : ''}
                `}>
                  <Icon 
                    name={action?.icon} 
                    size={16}
                    color={
                      action?.color === 'primary' ? 'var(--color-primary)' :
                      action?.color === 'secondary' ? 'var(--color-secondary)' :
                      'var(--color-accent)'
                    }
                  />
                </div>
                <span className="font-medium">{action?.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          w-14 h-14 rounded-full shadow-elevation-3 flex items-center justify-center
          transition-smooth hover:scale-105 active:scale-95
          ${isOpen ? 'bg-muted rotate-45' : 'bg-primary'}
        `}
        aria-label="Quick actions"
        aria-expanded={isOpen}
      >
        <Icon 
          name="Plus" 
          size={24} 
          color={isOpen ? 'var(--color-foreground)' : 'var(--color-primary-foreground)'}
        />
      </button>
    </div>
  );
};

export default QuickActions;